import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FadeLoader} from 'react-spinners';
import Modal from '../../components/Modal';


const renderTable = (registros) => {
    if (registros ) {
        return registros.map((item, index) => (
            <tr key={index} >
                <td>{item}</td>
            </tr>
        ));
    }
    return <tr>
        <td className='no-before' >No hay resultados</td>
    </tr>;
};

class VerErrores extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleShow = this.handleShow.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.state = {
            registros: this.props.registros,
        };
    }

    componentDidMount() {

    }


    handleShow() {
        this.setState({show: true});
    }

    handleHide() {
        this.setState({show: false});
    }

    render() {
        return (
            <div>
                <Modal idModal='ver-facturas' modalSize='modal-dialog' title='Detalle de Errores'
                       closeModal={this.props.closeModal}
                       isOpen
                >
                    <div className='steps-container fdvNew-slides'>
                        <div>
                            <div>
                                <div className='tableWrapper hide-scroll'>
                                    <table className='table table-hover'>
                                        <thead className='table-head'>
                                        <tr>
                                            <th>Descripción</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.props.registros
                                                ? renderTable(this.props.registros)
                                                : <tr>
                                                    <td className='no-before' colSpan={1}><FadeLoader color={'#F8A14A'}
                                                                                                      loading/></td>
                                                </tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='modal-actions'>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}


VerErrores.defaultProps = {

};

export default connect(mapStateToProps,
{

})(VerErrores);



// WEBPACK FOOTER //
// ./src/pages/Inmatriculacion/verErrores.js